export const version = '12.4.1';
export const buildDate = '2025-02-10T13:11:41.099Z';
export const commitHash = '631f3e3';